<template>
  <div>
    <a-drawer
      :width="1000"
      :visible="showCreateForm"
      :body-style="{ paddingBottom: '15px', paddingTop: '15px' }"
      class="create-kuaishou-ad-page"
      @close="close"
    >
      <a-form-model ref="form" :model="model" :rules="rules" >
        <a-spin :spinning="loading" tip="Loading..." size="large" />

        <a-steps type="navigation" size="small" :current="current">
          <a-step v-for="item in steps" :key="item.title" :title="item.title" />
        </a-steps>

        <div class="step" v-if="current === 0">
          <a-form-model-item label="广告主" prop="ids">
            <adv-select v-model="model.ids" :max-tag-count="3" :type="media" @blur="changeAdvs" />
          </a-form-model-item>

          <a-form-model-item label="计划模式" prop="unit.campaign_model" >
            <a-radio-group v-model="model.campaign_model" :disabled="!model.ids || model.ids.length<1" @change="changeCampaignModel">
              <a-radio-button :value="1" >新建计划</a-radio-button>
              <a-radio-button :value="2" >选择已有计划</a-radio-button>
            </a-radio-group>
          </a-form-model-item>


          <template v-if="model.campaign_model == 2">

            <a-form-model-item label=""  help='' style="border: 1px solid #87e8de;;padding:20px">
              <a-tabs :default-active-key="0" @change="clickPaneCampaign" size="small" tabPosition="left"  :style="{ height: '300px' }">
                <a-tab-pane  :tab="advertiser.name" v-for="(advertiser,index) in advertisers" :key="index" >
                  <a-form-model-item label="快手广告主ID">
                    <a-input v-model="advertisers[index].advertiser_id" disabled />
                  </a-form-model-item> 
                  
                 
                  <a-form-model-item label="关联计划" >
                    <a-row>
                      <a-col :span="18">
                        <a-select
                          show-search
                          allow-clear
                          placeholder="请选择"
                          v-model="advertisers[index].campaign_id"
                          option-filter-prop="children"
                          :loading="loading"
                        >
                          <a-select-option :value="item.campaign_id" v-for="item in campaigns[advertiser.id]" :key="item.campaign_id" :adv_id="advertiser.id">
                            {{ item.campaign_name }}（计划ID: {{ item.campaign_id }}）
                          </a-select-option>
                        </a-select>
                      </a-col>
                      <a-col :span="6">
                          <a-button @click="refreshCampaigns(advertiser.id)" style="margin-left:20px">
                            刷新计划
                          </a-button>
                      </a-col>
                    </a-row>
                  </a-form-model-item>

                </a-tab-pane>
    
              </a-tabs>
            </a-form-model-item>

          </template>

          <template v-else>
        
                <a-form-model-item label="营销目标" prop="type">
                  <a-radio-group v-model="model.type">
                    <!-- <a-radio-button :value="5">收集销售线索</a-radio-button> -->
                    <a-radio-button :value="30">快手号推广-短剧推广</a-radio-button>
                  </a-radio-group>
                </a-form-model-item>

                <a-form-model-item label="计划类型" prop="ad_type">
                  <a-radio-group v-model="model.ad_type">
                    <a-radio-button :value="0">展示广告</a-radio-button>
                    <a-radio-button :value="1" :disabled="true">搜索广告</a-radio-button>
                  </a-radio-group>
                </a-form-model-item>

                <a-form-model-item label="投放模式" prop="auto_manage">
                  <a-radio-group v-model="model.auto_manage">
                    <a-radio-button :value="1" >全自动投放</a-radio-button>
                    <a-radio-button :value="0">常规投放</a-radio-button>
                  </a-radio-group>
                </a-form-model-item>


                <a-form-model-item label="竞价策略" prop="bid_type">
                  <a-radio-group v-model="model.bid_type" @change="changeBidType">
                    <a-radio-button :value="type.id" v-for="type in bidTypes" :key="type.id" >{{ type.name }}</a-radio-button>
                  </a-radio-group>
                </a-form-model-item>

                <a-form-model-item label="计划日预算" prop="day_budget">
                  <a-radio-group v-model="model.budget_type" >
                    <a-radio-button :value="type.id" :disabled="type.disabled || model.bid_type == 1 && type.id == 0" v-for="type in budgetTypes" :key="type.id">{{ type.name }}</a-radio-button>
                  </a-radio-group>

                  <a-input-number
                    class="mt-10"
                    placeholder="不小于200, 仅支持整数"
                    v-model="model.day_budget"
                    addon-after="元"
                    :min="200"
                    :value="0"
                    v-if="model.budget_type === 1"
                  />
                </a-form-model-item>

                <a-form-model-item label="广告成本约束"  v-if="model.bid_type == 1">
                  <a-radio-group v-model="model.ys" disabled>
                    <a-radio-button :value="1">不限</a-radio-button>
                    <a-radio-button :value="2">ROI约束</a-radio-button>
                    <a-radio-button :value="3">非ROI单约束</a-radio-button>
                    <a-radio-button :value="4">非ROI双约束</a-radio-button>
                  </a-radio-group>
                </a-form-model-item>

                <a-form-model-item prop="name" label="计划名称">
                  <a-input v-model="model.name"  />
                </a-form-model-item>

                <a-form-model-item prop="num" label="计划数量" help="每个账户要生成的计划数量，最大不能超过10个">
                  <a-input-number :min="1" :max="10" :precision="0" v-model="model.num" disabled/>
                </a-form-model-item>

        </template>
    
        </div>

        <div class="step" v-if="current === 1">

          <a-form-model-item label="资源版位" prop="bw" help="可触达快手主站及快手系媒体流量">
            <a-radio-group v-model="model.bw">
              <a-radio-button :value="1">快手主站</a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item label="" prop="scene_id" >
            <byted-checkbox-group v-model="model.scene_id">
              <byted-checkbox-button :val="6">上下滑大屏广告</byted-checkbox-button>
              <byted-checkbox-button :val="7">信息流广告</byted-checkbox-button>
              <byted-checkbox-button :val="24">激励视频广告</byted-checkbox-button>
            </byted-checkbox-group>
          </a-form-model-item>

          <a-form-model-item label="目标快手号" prop="unit.live_user_id">
            <a-row>
              <a-col :span="18">
                  <a-select
                    show-search
                    placeholder="请选择"
                    v-model="model.unit.live_user_id"
                    option-filter-prop="children"
                    @change="changeKolUser"
                  >
                    <a-select-option :value="aweme.id" v-for="aweme in awemes" :key="aweme.id">
                      {{ aweme.name }}
                    </a-select-option>
                  </a-select>
              </a-col>
              <a-col :span="6">
                  <a-button :loading="refreshingAwemes" @click="refreshAwemes" style="margin-left:20px">
                    刷新快手号
                  </a-button>
              </a-col>
            </a-row>
          </a-form-model-item>

          <a-form-model-item label="短剧选择" prop="unit.series_id" v-if="model.unit.live_user_id">
            <!-- 搜索区 -->
            <a-row :gutter="8" style="margin-bottom: 8px">
              <a-col :span="18">
                <a-input
                  v-model="seriesKeyword"
                  placeholder="请输入短剧名称"
                  allow-clear
                />
              </a-col>
              <a-col :span="6">
                <a-button
                  :loading="seriesSearchLoading"
                  @click="searchSeries"
                  style="margin-left:20px"
                >
                  查询
                </a-button>
              </a-col>
            </a-row>
            <a-select
              show-search
              placeholder="请选择"
              v-model="model.unit.series_id"
              option-filter-prop="children"
              @change="changeSeries"
            >
              <a-select-option :value="item.id" v-for="item in series" :key="item.id">
                {{ item.title }}    <a-divider type="vertical" /> 共{{ item.episode_amount }}集
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="集数选择" prop="unit.episode_id" v-if="model.unit.series_id">
            <a-select
              show-search
              placeholder="请选择"
              v-model="model.unit.episode_id"
              option-filter-prop="children"
            >
              <a-select-option :value="item.id" v-for="item in episodes" :key="item.id">
                {{ item.name }}【{{ item.order_no+1 }}】
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="付费模式" prop="unit.series_pay_mode" v-if="model.unit.series_id">
            <a-select
              show-search
              placeholder="请选择"
              v-model="model.unit.series_pay_mode"
              option-filter-prop="children"
              @change="changePayMode"
            >
              <a-select-option :value="item.pay_mode" v-for="item in pay_model_types" :key="item.pay_mode">
                {{ item.pay_mode_desc }}
              </a-select-option>
            </a-select>
          </a-form-model-item>


          <template v-if="model.unit.series_pay_mode === 1">
                <a-form-model-item label="付费模版模式" prop="unit.template_model" >
                  <a-radio-group v-model="model.unit.template_model" @change="changeProductModel">
                    <a-radio-button :value="1" >统一设置</a-radio-button>
                    <a-radio-button :value="2" >分别设置</a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
      
                <template v-if="model.unit.template_model == 1">
                  <a-form-model-item label="付费模板" prop="unit.series_pay_template_ids">
                    <a-select
                      show-search
                      allow-clear
                      mode="multiple"
                      :maxTagCount="5"
                        placeholder="请选择（最多5个）"
                      v-model="model.unit.series_pay_template_ids"
                      option-filter-prop="children"
                    >
                      <a-select-option :value="item.series_pay_template_id" v-for="item in pay_templates" :key="item.series_pay_template_id">
                        {{ item.template_name }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </template>
      
                <template v-else>
                  <a-form-model-item style="border: 1px solid #87e8de;;padding:20px">
                    <a-row type="flex"  v-for="(item, key) in advertisers" :key="key" >
                      <a-col flex="240px" style="height:40px;line-height:40px"> {{ item.name }}</a-col>
                      <a-col flex="auto">
                          <a-select
                              show-search
                              placeholder="请选择"
                              v-model="advertisers[key].series_pay_template_id"
                              option-filter-prop="children"
                            >
                            <a-select-option :value="item.series_pay_template_id" v-for="item in pay_templates" :key="item.series_pay_template_id">
                              {{ item.template_name }}
                            </a-select-option>
                          </a-select>
                      </a-col>
                    </a-row>
                  </a-form-model-item>
                </template>
          </template>
        
          <div v-show="false">
            <a-form-model-item label="商品库模式" prop="unit.product_model">
              <a-radio-group v-model="model.unit.product_model" @change="changeProductModel">
                <a-radio-button :value="1" >统一设置</a-radio-button>
                <a-radio-button :value="2" >分别设置</a-radio-button>
              </a-radio-group>
            </a-form-model-item>

            <template v-if="model.unit.product_model === 1">
                <a-form-model-item label="关联商品库" prop="unit.library_id">
                      <a-row>
                        <a-col :span="18">
                          <a-select
                            show-search
                            allow-clear
                            placeholder="请选择"
                            v-model="model.unit.library_id"
                            option-filter-prop="children"
                            :loading="loading"
                            @change="changeLibrary"
                          >
                            <a-select-option :value="platform.id" v-for="platform in products[model.ids[0]]" :key="platform.id" >
                              {{ platform.name }}（ID:{{ platform.id }}）
                            </a-select-option>
                          </a-select>
                        </a-col>
                        <a-col :span="6">
                            <a-button @click="refreshProducts(model.ids[0], model.unit.library_id)" style="margin-left:20px">
                              刷新商品库
                            </a-button>
                        </a-col>
                      </a-row>
                      
                    </a-form-model-item>

                    <a-form-model-item label="关联产品" prop="unit.product_id" :loading="loading">
                      <a-select show-search allow-clear placeholder="请选择" v-model="model.unit.product_id" option-filter-prop="children" @change="changeProduct">
                        <a-select-option :value="detail.id" v-for="detail in productDetails[model.unit.library_id]" :key="detail.id" :outer_id="detail.outer_id">
                          {{ detail.name }}（ID:{{ detail.id }}）
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
            </template>
            <template v-else>


                  <a-form-model-item label=""  help='' style="border: 1px solid #87e8de;;padding:20px">
                    <a-tabs :default-active-key="0" @change="clickPane" size="small" tabPosition="left"  :style="{ height: '300px' }">
                      <a-tab-pane  :tab="advertiser.name" v-for="(advertiser,index) in advertisers" :key="index" >
                        <a-form-model-item label="快手广告主ID">
                          <a-input v-model="advertisers[index].advertiser_id" disabled />
                        </a-form-model-item> 
                        
                      
                        <a-form-model-item label="关联商品库" >
                          <a-row>
                            <a-col :span="18">
                              <a-select
                                show-search
                                allow-clear
                                placeholder="请选择"
                                v-model="advertisers[index].library_id"
                                option-filter-prop="children"
                                :loading="loading"
                                @change="changeLibrary"
                              >
                                <a-select-option :value="platform.id" v-for="platform in products[advertiser.id]" :key="platform.id" :adv_id="advertiser.id">
                                  {{ platform.name }}（ID:{{ platform.id }}）
                                </a-select-option>
                              </a-select>
                            </a-col>
                            <a-col :span="6">
                                <a-button @click="refreshProducts(advertiser.id, advertiser.library_id)" style="margin-left:20px">
                                  刷新商品库
                                </a-button>
                            </a-col>
                          </a-row>
                          
                        </a-form-model-item>
      
                        <a-form-model-item label="关联产品" :loading="loading">
                          <a-select show-search allow-clear placeholder="请选择" v-model="advertisers[index].product_id" option-filter-prop="children" @change="changeProduct">
                            <a-select-option :value="detail.id" v-for="detail in productDetails[advertiser.library_id]" :key="detail.id" :outer_id="detail.outer_id" :adv_id="advertiser.id" :id="detail.id">
                              {{ detail.name }}（ID:{{ detail.id }}）
                            </a-select-option>
                          </a-select>
                        </a-form-model-item>

                      </a-tab-pane>
          
                    </a-tabs>
                  </a-form-model-item>

            </template>
          </div>

          <a-form-model-item label="搜索快投" prop="unit.quick_search">
            <a-switch default-checked disabled v-model="model.unit.quick_search" />
          </a-form-model-item>


          <a-form-model-item label="搜索人群探索" prop="unit.target_explore">
            <a-switch default-checked disabled v-model="model.unit.target_explore" />
          </a-form-model-item>

        
          <a-form-model-item label="智能定向" prop="unit.intelli_extend_option">
            <a-switch v-model="model.unit.intelli_extend_option" />
          </a-form-model-item>

          <a-form-model-item label="地区" prop="unit.region_type">
            <a-radio-group v-model="model.unit.region_type">
              <a-radio-button :value="0">不限</a-radio-button>
              <a-radio-button :value="1" :disabled="true">指定区域</a-radio-button>
              <a-radio-button :value="2" :disabled="true">城市等级</a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item label="性别" prop="unit.gender">
            <a-radio-group v-model="model.unit.gender">
              <a-radio-button :value="0">不限</a-radio-button>
              <a-radio-button :value="2">男</a-radio-button>
              <a-radio-button :value="1">女</a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item label="年龄" prop="unit.ages_range">
            <a-checkbox-group v-model="model.unit.ages_range" @change="changeAge">
              <a-checkbox name="age" :value="age.id" v-for="age in ages" :key="age.id">
                {{ age.name }}
              </a-checkbox>
            </a-checkbox-group>
          </a-form-model-item>

          <a-form-model-item label="投放日期" prop="unit.date_type">
            <a-radio-group v-model="model.unit.date_type">
              <a-radio-button :value="0">长期投放</a-radio-button>
              <a-radio-button :value="1" :disabled="true">设置开始和结束日期</a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item label="投放开始日期" prop="unit.begin_time">
            <a-date-picker style="width: 100%;" valueFormat="YYYY-MM-DD" :disabled-date="disabledDate" v-model="model.unit.begin_time" />
          </a-form-model-item>

          <a-form-model-item label="单日预算" prop="unit.day_budget">
            <a-radio-group v-model="model.unit.budget_type" @change="changeUnitBudgetType">
              <a-radio-button :value="type.id" :disabled="type.disabled || model.bid_type == 1 && type.id != 0" v-for="type in budgetTypes" :key="type.id">{{ type.name }}</a-radio-button>
            </a-radio-group>

            <a-input-number
              class="mt-10"
              placeholder="不小于100"
              v-model="model.unit.day_budget"
              addon-after="元"
              :min="100"
              :value="0"
              v-if="model.unit.budget_type === 1"
            />
          </a-form-model-item>

          <a-form-model-item label="出价方式" prop="auto_manage">
            <a-radio-group v-model="model.unit.bid_type">
              <a-radio-button :value="10" :disabled="model.bid_type == 1 ? true : false">oCPM</a-radio-button>
              <a-radio-button :value="2" :disabled="true">CPC</a-radio-button>
              <a-radio-button :value="12" :disabled="model.bid_type != 1 ? true : false">MCB最大转化</a-radio-button>
            </a-radio-group>
          </a-form-model-item>

        
          <a-form-model-item label="转换目标与出价" >
            <a-select
              show-search
              placeholder="请选择"
              v-model="model.unit.ocpx_action_type"
              option-filter-prop="children"
              :loading="loading"
            >
              <a-select-option :value="action.id" :disabled="!action.disabled && model.unit.series_pay_mode != 1 || model.unit.series_pay_mode == 1 && action.is_pay == true ? false:true" v-for="action in ocpxActions" :key="action.id">
                {{ action.name }}
              </a-select-option>
            </a-select>
            <div class="mt-10"></div>
          </a-form-model-item>

          <a-form-model-item label="账户出价模式" prop="unit.price_model">
            <a-radio-group v-model="model.unit.price_model">
              <a-radio-button :value="1" >统一设置</a-radio-button>
              <a-radio-button :value="2" >分别设置</a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <template v-if="model.unit.price_model == 1">
              <a-form-model-item label="出价" prop="unit.cpa_bid"  v-if="[190,773].includes(model.unit.ocpx_action_type)"  help="范围1.0~3000.0 元" >
                <a-input-number class="mt-10" placeholder="范围1.0~3000.0 元" v-model="model.unit.cpa_bid" addon-after="元" :min="1" :max="3000" />
              </a-form-model-item>

              <a-form-model-item label="深度转化目标" v-if="model.unit.ocpx_action_type === 190">
                <a-select
                  allow-clear
                  placeholder="请选择"
                  v-model="model.unit.deep_conversion_type"
                  option-filter-prop="children"
                  :loading="loading"
                >
                  <a-select-option  v-for="item in deepConversionTypes" :key="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
                <div class="mt-10"></div>
              </a-form-model-item>

              <a-form-model-item label="" prop="unit.roi_ratio" v-if="[191,990].includes(model.unit.ocpx_action_type) || model.unit.deep_conversion_type == 92">
                <a-input v-model="model.unit.roi_ratio" placeholder="ROI系数，如期望值10%则输入0.1"  />
              </a-form-model-item>

          </template>

          <template v-else>
            <div style="border: 1px solid #87e8de;;padding:20px">
              <a-form-model-item  v-if="[190,773].includes(model.unit.ocpx_action_type)" style="padding:20px">
                <a-row type="flex"  v-for="(item, key) in advertisers" :key="key" >
                  <a-col flex="240px" style="height:40px;line-height:40px"> {{ item.name }}</a-col>
                  <a-col flex="auto">
                    <div style="height:10px">出价：</div> 
                    <a-input-number class="mt-10" placeholder="出价范围1.0~3000.0 元" v-model="advertisers[key].cpa_bid" addon-after="元" :min="1" :max="3000" />
                  </a-col>
                  <a-col flex="auto"  v-if="model.unit.ocpx_action_type == 190">
                    <div style="height:20px">深度转化目标：</div><a-select
                            allow-clear
                            placeholder="请选择"
                            v-model="advertisers[key].deep_conversion_type"
                            option-filter-prop="children"
                            :loading="loading"
                          >
                        <a-select-option  v-for="item in deepConversionTypes" :key="item.id">
                          {{ item.name }}
                        </a-select-option>
                      </a-select>
                  </a-col>
                  <a-col flex="auto" v-if="model.unit.ocpx_action_type == 190 && advertisers[key].deep_conversion_type == 92">
                    <div style="height:20px">ROI系数：</div> 
                    <a-input v-model="advertisers[key].roi_ratio" placeholder="ROI系数，如期望值10%则输入0.1"  />
                  </a-col>
                </a-row>
              </a-form-model-item>
  

              <a-form-model-item  v-if="[191,990].includes(model.unit.ocpx_action_type) "  style="padding:20px">
                <a-row type="flex"  v-for="(item, key) in advertisers" :key="key" >
                  <a-col flex="240px" style="height:40px;line-height:40px"> {{ item.name }}</a-col>
                  <a-col flex="auto">
                    <a-input v-model="advertisers[key].roi_ratio" placeholder="ROI系数，如期望值10%则输入0.1"/>
                  </a-col>
                </a-row>
              </a-form-model-item>


            </div>
          </template>
        



          <a-form-model-item prop="unit.name" label="广告组名称">
            <a-input v-model="model.unit.name"  />
          </a-form-model-item>

          <a-form-model-item prop="num" label="广告组数量" help="每个计划要生成的广告组数量">
            <a-input-number :min="1" :precision="0" v-model="model.unit.num" />
          </a-form-model-item>
        </div>

        <div class="step" v-if="current === 2">

          <a-form-model-item label="制作方式" prop="creative.creative_type">
            <a-radio-group v-model="model.creative.creative_type" @change="changeCreativeType">
              <a-radio-button :value="1" >自定义创意</a-radio-button>
              <a-radio-button :value="2">程序化创意</a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item
            v-if="model.creative.creative_type === 1"
            label="爆款裂变开关"
            prop="creative.micro_change_switch"
          >
            <a-switch default-checked v-model="model.creative.micro_change_switch" />
          </a-form-model-item>

          <a-form-model-item label="素材来源" prop="creative.material_source_type">
            <a-tabs v-model="model.creative.material_source_type" @change="changeMaterialSourceType">
              <a-tab-pane key="1" tab="广告素材">
                <div v-if="currentAdvId > 0" style="margin-top: 8px;">
                  <a-form-model-item prop="creative.video_ids" help="所选素材将随机平均分配至每个广告组">
                    <video-select
                      v-model="model.creative.video_ids"
                      :max-num="model.num * 100"
                      :advertiser-id="currentAdvId"
                      :media="media"
                    />
                  </a-form-model-item>
                </div>
              </a-tab-pane>
              <a-tab-pane key="2" tab="素材名称">
                <div style="margin-top: 8px;">
                  <a-form-model-item prop="creative.material_name" help="输入素材名称后，点击查询获取已推送的素材">
                    <a-input-group compact>
                      <a-input
                        v-model="model.creative.material_name"
                        placeholder="请输入素材名称"
                        allow-clear
                        @change="onMaterialNameChange"
                        style="width: 300px"
                      />
                      <a-button type="primary" :loading="materialCountsLoading" :disabled="materialCountsLoading" @click="queryMaterialCounts">查询</a-button>
                    </a-input-group>
                  </a-form-model-item>
                  <div v-if="materialCounts.length > 0" style="margin-top: 8px; max-height: 260px; overflow-y: auto; line-height: 2;">
                    <a-tag
                      v-for="item in materialCounts"
                      :key="item.advertiser_id"
                      color="blue"
                      style="margin-bottom: 4px;"
                    >
                      {{ item.advertiser_name }}（{{item.advertiser_id}}）: {{ item.count }}个素材
                    </a-tag>
                  </div>
                  <div v-else-if="materialCountsLoaded && model.creative.material_name" style="margin-top: 8px; color: #999;">
                    未找到匹配的推送素材
                  </div>
                </div>
              </a-tab-pane>
              <a-tab-pane key="3" tab="AI视频">
                <div v-if="currentAdvId > 0" style="margin-top: 8px;">
                  <a-form-model-item prop="creative.video_ids" help="所选素材将随机平均分配至每个广告组">
                    <video-select
                      v-model="model.creative.video_ids"
                      :max-num="model.num * 100"
                      :advertiser-id="currentAdvId"
                      :media="media"
                      :material-source-type="'3'"
                      :series-id="model.unit.series_id"
                    />
                  </a-form-model-item>
                </div>
              </a-tab-pane>
            </a-tabs>
          </a-form-model-item>

          <a-form-model-item label="素材分配规则" prop="creative.material_rule">
            <a-radio-group v-model="model.creative.material_rule">
              <a-radio-button :value="1">平均分配</a-radio-button>
              <a-radio-button :value="2">自定义</a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item prop="creative.material_num" label="广告素材数量" help="每个广告的素材数量" v-if="model.creative.material_rule == 2">
            <a-input-number :min="1" :precision="0" v-model="model.creative.material_num" />
          </a-form-model-item>

          <a-form-model-item label="作品广告语" prop="creative.description">
            <code-input ref="title_group" class="title-group" v-model="model.creative.description"  />
            <div slot="help">
              <span>多个标题可按回车分隔</span>
              <a-select show-search allow-clear placeholder="标题库" style="width: 120px" size="small">
                <a-select-option :value="group.id" v-for="group in titleGroups" :key="group.id" @click="setTitleGroup(group)">
                  {{ group.name }}
                </a-select-option>
              </a-select>
            </div>
          </a-form-model-item>

          <a-form-model-item label="行动号召" prop="creative.action_bar_text">
            <a-select
              show-search
              allow-clear
              placeholder="请选择"
              v-model="model.creative.action_bar_text"
              option-filter-prop="children"
            >
              <a-select-option :value="button" v-for="button in buttons" :key="button">
                {{ button }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="推荐理由" prop="creative.new_expose_tag">
            <a-select
              show-search
              allow-clear
              placeholder="可空，最多2个标签"
              v-model="model.creative.new_expose_tag"
              option-filter-prop="children"
              mode="multiple" 
            >
              <a-select-option :value="item" v-for="item in newExposeTags" :key="item">
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="创意分类" prop="creative.creative_category">
            <a-select
              show-search
              allow-clear
              placeholder="请选择"
              v-model="model.creative.creative_category"
              option-filter-prop="children"
            >
              <a-select-option :value="70301">互联网软件服务 / 影音视频 / 短视频</a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="创意标签" prop="creative.creative_tag" help="最多10个标签，每个不超过10个字符，可使用回车分隔">
            <a-select
              mode="tags"
              show-search
              allow-clear
              placeholder="请选择"
              v-model="model.creative.creative_tag"
              option-filter-prop="children"
            >
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="点击监测" prop="creative.click_track_url">
            <a-input v-model="model.creative.click_track_url" placeholder="无需使用监测链接请留空"  />
          </a-form-model-item>

          <a-form-model-item label="是否开启原生" prop="creative.outer_loop_native">
            <a-switch default-checked v-model="model.creative.outer_loop_native" />
          </a-form-model-item>
       
          <a-form-model-item label="创意名称" prop="creative.name">
            <a-input v-model="model.creative.name"  />
          </a-form-model-item>
        </div>

        <div class="step" v-if="current === 3">
          <a-result
            status="success"
            title="提交成功"
            sub-title="该任务为异步执行，请稍后在任务列表中查看状态"
          >
          <!-- <a-button v-if="current > 0" @click="prev">上一步</a-button> -->
          </a-result>
 
        </div>

        <div class="steps-action">
          <a-space class="button-group">
            <template v-if="current < 3">
              <a-button v-if="current === 0" @click="close">取消</a-button>
              <a-button v-if="current > 0" @click="prev">上一步</a-button>
              <a-button v-if="current < steps.length - 2" type="primary" @click="next">下一步</a-button>
              <a-button v-if="current === steps.length - 2" type="primary" @click="submit">提交</a-button>
            </template>

            <template v-if="current === steps.length - 1">
              <a-button :loading="loading" :disabled="loading" @click="close">
                {{ loading ? '任务执行中' : '确认并关闭' }}
              </a-button>
            </template>
          </a-space>

        </div>
      </a-form-model>
    </a-drawer>
  </div>
</template>

<style lang="less" scoped>
@import 'Kuaishou';
</style>

<script>
import Kuaishou from './Kuaishou'
export default Kuaishou
</script>
